// extracted by mini-css-extract-plugin
export default {"loader":"loader_loader__-OZxy"};